import { useTLang } from 'intl/intl';

export function useTitleOfCustomLang() {
  return {
    paragraph: {
      second: {
        label: useTLang({ id: 'menuPage.customsGroups.secondary.label' }),
      },
    },
  };
}
